export default "__VITE_ASSET__DaTpb7ox__"